export default __webpack_public_path__ + "static/media/Exo-Black.8cc5e751.ttf";